export default () => {
    return {
        feedback: {
            title: '¿Qué te pareció el texto?',
            success1: 'Gracias. ¿Cómo podemos mejorar más?',
            success2: 'Gracias. ¿Cómo podemos mejorar?',
            success3: '¡Gracias por el feedback!',
            error: 'Lo sentimos, se produjo un error al enviar sus comentarios!',
            send: 'Enviar',
            textareaPlaceholder: 'Escribe aquí',
        },
    };
};
//# sourceMappingURL=es.js.map